
import { useContext, useEffect } from "react";
import { FormContextAMR } from "../form-context";
// import ontarioLogo from "../images/ontario-logo.png";
import medsCheckLogo from "../images/meds-check-logo.png";
import ontarioLeftLogo from "../images/ontario-left-logo.png";
import ontarioPharmaLogo from "../images/ontario-pharma-logo.png";
// import formHeader from "../images/form-header.png";

export const PatientAcknowledgmentForm = () => {
  const {
    formType,
    clinicalServiceName,
    patient,
    preAssessment,
    clinicalAssessment,
    documentation,
    education,
    startDateTime,
    endDateTime,
  } = useContext(FormContextAMR);

  // Task: MedsCheck Annual checked when form is completed with a medication review (form is only shown in MR context)
  const isMedsCheckAnnual = Boolean(clinicalServiceName);
  // Task: MedsCheck at Home only when "Start a Clinical Service" → user selected "Patient's Home" for the Medication review
  const isMedsCheckAtHome = preAssessment?.locationType === "Patient's Home";

  return (
    
    <div className="pa-form max-w-4xl mx-auto border-gray-400">


        <div className="w-full bg-white px-8 py-6">
            <div className="flex justify-between">
                {/* Left side - Ontario logo and ministry info */}
                <div className="flex  space-x-4">
                    {/* Ontario Trillium Logo */}
                    <div className="flex items-center">
                        <img src={ontarioLeftLogo} width="166" height="55" />
                    </div>
                    
                    {/* Ministry text */}
                    <div className="ml-8 self-end text-left">
                        <div className="text-black font-bold text-xs leading-snug tracking-normal" style={{fontFamily: 'Inter', fontSize: '12px', lineHeight: '100%'}}>Ministry of Health</div>
                        <div className="text-black font-bold text-xs leading-snug tracking-normal" style={{fontFamily: 'Inter', fontSize: '12px', lineHeight: '100%'}}>and Long-Term Care</div>
                    </div>
                </div>
                
                {/* Right side - MedsCheck logo */}
                <div className="flex flex-col justify-end items-end">
                    <img src={medsCheckLogo} width="196" height="32" />
                </div>
            </div>
        </div>
        {/* Gray header
        <div className="bg-gray-600 text-gray-300 text-sm p-2">
          MedsCheck Patient Acknowledgment of Professional Pharmacy Service
        </div> */}
        
        {/* White form area */}
        <div className="bg-white p-6 text-xs">
          

          {/* Main Title */}
          <div className="font-bold text-lg leading-snug tracking-normal pb-4">MedsCheck Patient Acknowledgment of Professional Pharmacy Service</div>
          
          {/* Description */}
          <p className="leading-tight mb-2">
            To be completed annually for MedsCheck Professional Pharmacy Services (excluding MedsCheck for Long-Term Care Home residents). To be
            filled at the pharmacy for documentation and auditing purposes. Please cross-reference with accompanying MedsCheck reviews; please provide
            a copy to the patient if/or patient's agent.
          </p>

          {/* Patient Information Section */}
          <div className="">
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  <td colSpan="6" className="bg-gray-20 px-2 py-1 font-bold text-sm border-t border-black">
                    Patient Information
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Last Name</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.lastName}</div>
                  </td>
                  <td colSpan="3" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">First Name</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.firstName}</div>
                  </td>
                </tr>
                <tr>
                  <td className="text-xs p-0 align-top border-black border-t border-r" style={{width: '16.66%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Unit Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.unitNumber}</div>
                  </td>
                  <td className="text-xs p-0 align-top border-black border-t border-r" style={{width: '16.66%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Street Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top  border-black border-t border-r" style={{width: '43.33%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Street Name</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="2" className="text-xs align-top border-black border-t" style={{width: '23.33%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">PO BOX</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.poBox}</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">City/Town</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.city}</div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Province</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.province}</div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">Postal Code</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.postalCode}</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Telephone Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.primaryPhone}</div>
                  </td>
                  <td colSpan="4" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">Email Address (if available)</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">{patient.contactInfo.email}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Pharmacy Information Section */}
          <div className="mb-4">
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  <td colSpan="6" className="bg-gray-20 px-2 py-1 font-bold text-sm border-black border-t">
                    Pharmacy Information
                  </td>
                </tr>
                <tr>
                  <td colSpan="6" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">Pharmacy Name</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">Vesna</div>
                  </td>
                </tr>
                <tr>
                  <td className="text-xs p-0 align-top border-black border-t border-r" style={{width: '16.66%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Unit Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">Store 4091</div>
                  </td>
                  <td className="text-xs p-0 align-top border-black border-t border-r" style={{width: '16.66%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Street Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10">Safeway</div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r" style={{width: '33.33%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">Street Name</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t" style={{width: '33.33%'}}>
                    <div className="font-semibold bg-white px-2 pt-2">PO BOX</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">City/Town</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Province</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">Postal Code</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Telephone Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td className="text-xs p-0 align-top border-black border-t border-r">
                    <div className="font-semibold bg-white px-2 pt-2">Fax Number</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                  <td colSpan="3" className="text-xs p-0 align-top border-black border-t">
                    <div className="font-semibold bg-white px-2 pt-2">Email Address (if available)</div>
                    <div className="h-6 px-2 pt-2 bg-gray-10"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* MedsCheck Reviews text */}
          <p className="text-xs leading-tight mb-3">
            MedsCheck Reviews typically occur at the pharmacy where there is a sufficient level of privacy that ensures patient confidentiality. A pharmacy
            team member will explain which program is best suited to your needs; this form is completed annually at any pharmacy that provides the
            program. MedsCheck Professional Pharmacy Services may include:
          </p>

          {/* Service checkboxes - auto-check per task: MedsCheck Annual when form completed with MR; MedsCheck at Home only when location was Patient's Home */}
          <div className="mb-3">
            <div className="flex items-center mb-1 text-xs">
              <input type="checkbox" className="mr-2 h-3 w-3" disabled readOnly checked={isMedsCheckAnnual} />
              <span className="mr-4">MedsCheck Annual</span>
              <input type="checkbox" className="mr-2 h-3 w-3" disabled readOnly checked={false} />
              <span className="mr-4">MedsCheck Follow-up</span>
              <input type="checkbox" className="mr-2 h-3 w-3" disabled readOnly checked={false} />
              <span className="mr-4">MedsCheck for Diabetes Annual</span>
              <input type="checkbox" className="mr-2 h-3 w-3" disabled readOnly checked={false} />
              <span>Diabetes Education Follow-up</span>
            </div>
            <div className="flex items-start text-xs">
              <input type="checkbox" className="mr-2 mt-0.5 h-3 w-3" disabled readOnly checked={isMedsCheckAtHome} />
              <span>MedsCheck at Home (also includes a medication cabinet clean-up and pharmacist disposal of unused medication from the patient's home with the patient's understanding)</span>
            </div>
          </div>

          <p className="text-xs mb-2">MedsCheck is a service that patients participate in voluntarily and is sponsored by the Ontario government.</p>

          {/* Bullet points */}
          <ul className="text-xs space-y-1 mb-3 ml-4">
            <li className="flex">
              <span className="mr-2">•</span>
              <span>Information about the MedsCheck program is available on the Ontario government and Ontario Pharmacists Association websites and/or on the Government patient brochure.</span>
            </li>
            <li className="flex">
              <span className="mr-2">•</span>
              <span>MedsCheck includes a completed MedsCheck personal medication record that is signed and dated by the pharmacist. The completed MedsCheck must be resolved or returned to inpatient drug therapy related problems identified by you, the pharmacist or your primary care provider.</span>
            </li>
            <li className="flex">
              <span className="mr-2">•</span>
              <span>The accuracy of the information on the final MedsCheck document depends on the accuracy and completeness of the information provided by the patient at the time the MedsCheck was performed.</span>
            </li>
            <li className="flex">
              <span className="mr-2">•</span>
              <span>The completed MedsCheck document and this patient acknowledgment demonstrate that both parties have an understanding of the MedsCheck program and the process.</span>
            </li>
            <li className="flex">
              <span className="mr-2">•</span>
              <span>As a member of your health-care team, your pharmacist may confidentially share the completed MedsCheck with other health Care professionals to ensure that the relevant members of your health care team are up to date on your current medication profile. Exchange of the MedsCheck medication review will be done so in a manner to ensure the secure transfer of patient health information.</span>
            </li>
          </ul>

          {/* Patient Acknowledgement */}
          <div className="">
            <h3 className="font-bold text-sm mb-2">Patient Acknowledgement</h3>
            <p className="text-xs leading-tight mb-3">
              By signing this form, you are acknowledging participation in an in-person MedsCheck medication review with a pharmacist associated with the
              pharmacy noted above. It may be necessary for the pharmacist to discuss and share your health information with other health Care
              professionals (e.g., physician, nurses, etc.) in accordance with voluntary accepted medication therapy management principles. Your signature
              below will indicate that you acknowledge the secure exchange of information and your agreement to the meds check service.
            </p>
            
            {/* Signature fields - use signature from app during service (preAssessment.patientSignature) when available */}
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  <td className="text-xs p-0 align-top border-black border-t border-r" style={{width: '75%'}}>
                    <div className="font-semibold bg-white px-2 py-1">Patient/ Agent Signature</div>
                    <div className="h-9 px-2 py-1 bg-gray-10 min-h-[2.25rem]">
                      {preAssessment?.patientSignature || ""}
                    </div>
                  </td>
                  <td className="text-xs p-0 align-top border-black border-t" style={{width: '25%'}}>
                    <div className="font-semibold bg-white px-2 py-1">Date (yyyy/mm/dd)</div>
                    <div className="h-9 px-2 py-1 bg-gray-10 min-h-[2.25rem]">
                      {startDateTime
                        ? new Date(startDateTime).toISOString().split("T")[0].replace(/-/g, "/")
                        : ""}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Comments */}
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="text-xs p-0 align-top border-black border-t">
                  <div className="font-semibold bg-white px-2 py-1">Comments</div>
                  <div className="h-9 bg-gray-10"></div>
                </td>
              </tr>
            </tbody>
          </table>

          {/* Static footer line with form code and page info */}
          <div className="mt-1 flex w-full text-[9px] text-gray-700 items-center">
            <span className="flex-1">4975-47E (2022/11) &nbsp; &nbsp; © King&apos;s Printer for Ontario, 2022</span>
            <span className="flex-1 text-center">
              <img src={ontarioPharmaLogo} alt="Ontario Pharmacists Association" className="inline-block h-5 w-auto" />
            </span>
            <span className="flex-1 text-right">Page 1 of 1</span>
          </div>
      </div>
    </div>
  );
};
